import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-painel-fornecedor',
  templateUrl: './painel-fornecedor.component.html',
  styleUrls: ['./painel-fornecedor.component.scss']
})
export class PainelFornecedorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
